
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 1.125a7.875 7.875 0 100 15.75 7.875 7.875 0 000-15.75zM9 15.75a6.75 6.75 0 110-13.5 6.75 6.75 0 010 13.5z","fill":"#000"}}),_c('path',{attrs:{"d":"M7.313 9h1.125v4.5h1.124V7.875h-2.25V9zM9 6.75A1.125 1.125 0 109 4.5a1.125 1.125 0 000 2.25z","fill":"#000"}})])
          )
        }
      }
    